import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import utils from "../../Utils";
import strings from "../../Utils/strings";
import Widgets from "../../Widgets";
import "./HospitalLogin.css";
import { useTranslation } from "react-i18next";
import { DeviceUUID } from "device-uuid";
import PhoneInput from "react-phone-input-2";
import validations from "../../Utils/validations";
import { messaging } from "../../Firebase/config";
import { RecaptchaVerifier } from "firebase/auth";
import { signInWithPhoneNumber } from "firebase/auth";
import MobileOtpVerify from "../verifyMobileOTP/verifyMobileOTP";
import clinicService from "../../Services/clinicService";

function HospitalLogin() {
  const { t } = useTranslation();
  const countryArr = utils.list.countryCodeList;
  const nav = useNavigate();
  const state = useLocation();
  const [mobileMaxValue, setMobileMaxValue] = useState(8);
  const [mobile, setMobile] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [code, setCode] = useState(state.state != null ? state.state.countryCode : "65");
  const [phoneErr, setPhoneErr] = useState("");
  const [defaultCountry, setDefaultCountry] = useState(null);
  const [otpSent, setOtpSent] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [receivedOTP,setReceivedOTP]=useState("");

  useEffect(() => {
    validateSession();
  }, []);

  const [deviceId, setDeviceId] = useState("");
  useEffect(() => {
    const deviceUUID = new DeviceUUID().get();
    setDeviceId(deviceUUID);
    validateSession();
  }, []);

  const validateSession = () => {
    // if (authService.getToken()) {
    //     nav(strings.navigation.dashboard);
    // }
  };

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    const code = evt.keyCode ? evt.keyCode : evt.which;
    if (code === 13 && isValid && !mobile === "") {
      validateLogin();
    }
  };

  const getOTP = async () => {
    setIsSending(true);
    setPhoneErr("");
    try {
      const response = await setUpReCaptcha(`+${code}` + mobile);
      console.log("otp i think", response);
      if (response) {
        toast.success("OTP has been Sent to your Registered Mobile Number, please Check");
        setReceivedOTP(response);
        setOtpSent(true);
      }
    } catch (err) {
      console.error("Error in loginApiCall:", err);
      toast.error("Failed to verify phone number. Please try again.");
    } finally {
      setIsSending(false);
    }
    console.log(mobile);
  };

  const setUpReCaptcha = async (number) => {
    console.log(messaging);
    try {
      const recaptchaVerifier = new RecaptchaVerifier(messaging, "recaptcha-container", {
        size: "invisible",
        callback: (response) => {
          console.log(response);
        },
        "expired-callback": (res) => {
          console.log(res);
        },
      });
      console.log(recaptchaVerifier);
      await recaptchaVerifier.render();

      const confirmationResult = await signInWithPhoneNumber(messaging, number, recaptchaVerifier);

      recaptchaVerifier.clear();

      return confirmationResult;
    } catch (error) {
      console.error("An error occurred during reCAPTCHA setup:", error);
      throw error;
    }
  };

  const validateLogin = async() =>{
    let body = {
      countryCode: code,
      phoneNumber: mobile
  }
  try {
      let response = await clinicService.verifyHospitalLogin(body);
      if(response.status === "success"){
        // getOTP()
        setOtpSent(true)
      }else{
        setPhoneErr("Hospital does not exist")
      }
  } catch (error) {
      console.log("error", error)
  }
  }


  const mobileValidationHandler = (e) => {
    try {
      let item = e.target.value;
      const isValid = validations.phoneValidator(item, code, t);
      if (!isValid.status) {
        setPhoneErr(isValid.message ? isValid.message : "");
        setIsValid(false);
      } else {
        setIsValid(true);
        setPhoneErr("");
      }
      setMobile(isValid.item);
      console.log(item);
    } catch (e) {}
  };

  return (
    <>
      {isSending ? <Widgets.CircularLoader /> : ""}
      {otpSent ? (
        <MobileOtpVerify 
        receivedOTP={receivedOTP}
        code={code}
        mobile={mobile}
        />
      ) : (
        <div className="detail-container">
          <div>
            <h5 className="login-title">{t("hospitalAdminHeading")}</h5>
          </div>
          <form>
              <div className="form-group input-group-lg row mt-4 responsive-form">
              <div className="code-container">
                <PhoneInput
                  country={defaultCountry ? defaultCountry.code : null}
                  enableSearch={true}
                  value={code}
                  dropdownStyle={{
                    zIndex: "0.3rev !important",
                  }}
                  inputStyle={{ height: "50px" }}
                  onChange={(code) => {
                    setMobile("");
                    setPhoneErr("");
                    setIsValid(false);
                    setMobileMaxValue(code);
                    for (let i in utils.list.countryCodeList) {
                      if ("+" + code === countryArr[i].dial_code) {
                        setMobileMaxValue(countryArr[i].maxLen ? countryArr[i].maxLen : 12);
                      }
                    }
                    setCode(code);
                  }}
                />
              </div>
              <div className="number-container">
                <input
                  type="text"
                  data-toggle="tooltip"
                  title="Phone number"
                  placeholder={t("mobileNumberPlaceholder")}
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5"
                  style={{ height: "50px" }}
                  value={mobile}
                  maxLength={mobileMaxValue}
                  onChange={mobileValidationHandler}
                  onSubmit={validateLogin}
                />
                <div className="mt-2">
                  {phoneErr !== "" ? (
                    <span className="d-flex error-container">
                      {phoneErr && phoneErr.length > 0 ? <i className="ri-information-line me-1" /> : null}
                      {phoneErr}
                    </span>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="row">
              <button
                type="submit"
                className="buttonStyle mt-4 w-full text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                disabled={!(isValid && !mobile == "") || isSending}
                onClick={(e) => {
                  e.preventDefault();
                  validateLogin();
                }}
              >
                {t("continueBtn")}
              </button>
              <div id="recaptcha-container"></div>
            </div>
          </form>
          <div className="mt-4">
            <button
              type="button"
              className="buttonSecondary mt-2 w-full font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              onClick={() => {
                nav(strings.navigation.doctorLogin);
              }}
            >
              {t("loginAsDoctor")}
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default HospitalLogin;
